<div class="dialog">

  <app-header-dialog [iconName]="'mobile_friendly'">
    <span>Inscrições Falhas</span>
  </app-header-dialog>

  <div class='container'>

    <!-- TABLE -->
    <mat-table [dataSource]="orderedFailDataSource" style='overflow:auto;'>

      <ng-container matColumnDef="icon">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-icon style='font-size:1.2em; margin-top:10px;'>ballot</mat-icon>
        </mat-cell>
        <mat-cell mat-footer-cell *matFooterCellDef></mat-cell>
      </ng-container>

      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef> Data </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.date.seconds*1000 | date: 'dd/MM/yyyy' }}
        </mat-cell>
        <mat-cell mat-footer-cell *matFooterCellDef></mat-cell>
      </ng-container>


      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.name }} </mat-cell>
        <mat-cell mat-footer-cell *matFooterCellDef> </mat-cell>
      </ng-container>

      <ng-container matColumnDef="code">
        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span *ngIf='element.code'> {{ element.code }} </span>
        </mat-cell>
        <mat-cell mat-footer-cell *matFooterCellDef> </mat-cell>
      </ng-container>


      <ng-container matColumnDef="message">
        <mat-header-cell *matHeaderCellDef> Mensagem </mat-header-cell>

        <mat-cell *matCellDef="let element">
          <span *ngIf='element.message'> {{ element.message }} </span>
        </mat-cell>
        <mat-cell mat-footer-cell *matFooterCellDef> </mat-cell>
      </ng-container>

      <ng-container matColumnDef="total">
        <mat-header-cell *matHeaderCellDef> Valor </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.total | currency:'BRL':'':'1.2-2' }}
        </mat-cell>
        <mat-cell mat-footer-cell *matFooterCellDef> </mat-cell>
      </ng-container>

      <!-- Header -->

      <mat-header-row *matHeaderRowDef="displayedFailColumns"></mat-header-row>

      <!-- Row -->
      <mat-row *matRowDef="let row; columns: displayedFailColumns;"></mat-row>

      <!-- Footer
      <mat-row mat-footer-row *matFooterRowDef="displayedFailColumns; sticky: true"></mat-row>
-->

    </mat-table>
    <!-- END TABLE -->


  </div>